<template>
	<div class="m-news">
		<div class="m-news-head flex-between-center">
			<h1>{{unitData.title}}</h1>
			<p>
				<a>换一批</a>
				<ins>|</ins>
				<a>查看更多</a>
			</p>
		</div>
		<div class="m-news-list flex">
			<a v-for="(item, i) in unitData.product_list" :key="item.product_id" class="item">
				<c-image class="image" :src="item.product_img_url"></c-image>
				<p class="name ellipsis-2">{{item.product_name}}</p>
				<div class="flex-between-center">
					<div class="price">
						<b>￥{{item.sale_price}}</b>
						<del>￥{{item.original_sale_price}}</del>
					</div>
					<div class="tag">限时折扣</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-news {
		margin-top: 24px;
		background: #fff;
		
		&-head {
			height: 85px;
			padding: 0 20px;
			
			h1 {
				font-size: 24px;
			}
			
			p {
				font-size: 13px;
				color: #999;
				
				ins {
					margin: 0 6px;
				}
			}
		}
		
		&-list {
			padding: 0 20px 20px;
			
			.item {
				width: 250px;
				
				&:nth-child(n+2) {
					margin-left: 26px;
				}
				
				.image {
					height: 250px;
				}
				
				.name {
					height: 40px;
					margin: 8px 0;
					line-height: 20px;
					font-size: 13px;
					color: #444;
				}
				
				.price {
					line-height: 32px;
					
					b {
						font-size: 16px;
					}
					
					del {
						margin-left: 5px;
						font-size: 12px;
						color: #999;
					}
				}
				
				.tag {
					border: 1px solid #000;
					padding: 0 5px;
					line-height: 16px;
					font-size: 12px;
					color: #000;
				}
			}
		}
	}
</style>
